import { ContainerScansPluginApi } from "./types";
import { DiscoveryApi, IdentityApi } from "@backstage/core-plugin-api";
import { ContainerScansResponse } from "./types";

export class ContainerScansPluginBackendClient implements ContainerScansPluginApi {
    private readonly discoveryApi: DiscoveryApi;
    private readonly identityApi: IdentityApi;

    constructor(options: { discoveryApi: DiscoveryApi; identityApi: IdentityApi }) {
        this.discoveryApi = options.discoveryApi;
        this.identityApi = options.identityApi;
    }

    private async handleResponse(response: Response): Promise<any> {
        if (!response.ok) {
            throw new Error();
        }
        return await response.json();
    }

    async getHealth(): Promise<string> {
        const url = `${await this.discoveryApi.getBaseUrl("read-s3")}/health`;
        const {token} = await this.identityApi.getCredentials();
        const response = await fetch(url, {
            headers: token
                ? {
                    Authorization: `Bearer ${token}`,
                }
                : undefined,
            method: "GET",
        });
        return await this.handleResponse(response);
    }

    async getContainerScans(
        page = 0,
        pageSize = 20,
        sortBy = "severity",
        sortOrder: "asc" | "desc" = "asc",
        q = "",
    ): Promise<ContainerScansResponse> {
        const baseUrl = await this.discoveryApi.getBaseUrl("read-s3");

        const params = new URLSearchParams({
            page: String(page),
            pageSize: String(pageSize),
            sortBy,
            sortOrder,
        });

        if (q.trim()) {
            params.set("q", q.trim());
        }

        const url = `${baseUrl}/container-scans?${params.toString()}`;

        const { token } = await this.identityApi.getCredentials();
        const response = await fetch(url, {
            headers: token ? { Authorization: `Bearer ${token}` } : undefined,
            method: "GET",
        });

        return await this.handleResponse(response);
    }


    async getContainerScansCsv(): Promise<Response> {
        const url = `${await this.discoveryApi.getBaseUrl("read-s3")}/container-scans-csv`;
        const { token } = await this.identityApi.getCredentials();
        const response = await fetch(url, {
            headers: token
                ? {
                    Authorization: `Bearer ${token}`,
                    Accept: "text/csv",
                }
                : { Accept: "text/csv" },
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Failed to fetch CSV");
        }
        return response;
    }

    async getContainerScansSummary(): Promise<Response> {
        const url = `${await this.discoveryApi.getBaseUrl("read-s3")}/container-scans-summary`;
        const { token } = await this.identityApi.getCredentials();
        const response = await fetch(url, {
            headers: token
                ? {
                    Authorization: `Bearer ${token}`,
                }
                : undefined,
            method: "GET",
        });
        if (!response.ok) {
            throw new Error("Failed to fetch summary");
        }
        return response;
    }

}


